import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LandingPage.css';

const VELOCITY_THRESHOLD = 0.15;
const DISTANCE_THRESHOLD = 20;
const NUM_SLIDES = 1; // slides 2–4 temporarily disabled

const MSC_LOGO = (
  <svg viewBox="0 0 1004.85 500" xmlns="http://www.w3.org/2000/svg">
    <path d="M262.89,461.45a228.07,228.07,0,0,0,81-15.29,13.84,13.84,0,0,1,4.86-1.12c2.74,0,4.78,1.5,6.38,5.18l8.93,20.58a10,10,0,0,1,1,3.93c0,2.81-1.79,5.1-6.08,6.79A263.65,263.65,0,0,1,263.48,500,262.08,262.08,0,0,1,150.28,1.36,11.93,11.93,0,0,1,155.33,0c2.91,0,4.85,1.8,6.2,4.9L170,24.33a15.8,15.8,0,0,1,1.67,5.9c0,2.62-1.65,4.42-5.73,6.38C88.8,73.75,40,149.55,40,238c0,59.69,22.68,115.8,64.89,158A222,222,0,0,0,262.89,461.45Z" transform="translate(-1)"/>
    <path d="M331.15,396.85c0,2.88-1.91,4.93-6.35,6.6a175.26,175.26,0,0,1-61.9,11.17C165.51,414.62,86,335.39,86,238S165.51,61.37,262.9,61.37a175.13,175.13,0,0,1,63.4,11.74c2.85,1.09,4.74,3.07,4.74,6.15A11.45,11.45,0,0,1,330,83.78l-8.86,20.34c-1.51,3.47-3.3,5.16-6.19,5.16a13.38,13.38,0,0,1-4.55-1c-15-5.56-28.8-8.37-47.45-8.37-76.13,0-137.9,62-137.9,138.08s61.77,138.07,137.9,138.07A137,137,0,0,0,309.5,368a16.22,16.22,0,0,1,5.29-1.18c2.77,0,4.75,1.5,6.47,5.45l8.73,20A11.68,11.68,0,0,1,331.15,396.85Z" transform="translate(-1)"/>
    <path d="M356.52,233.46c0-.21,0-.42,0-.63-2.34-30.58-17.57-56.94-42.72-73a92.08,92.08,0,0,0-50.14-14.7,87.74,87.74,0,0,0-30,5c-3.76,1.47-5.66,3.74-5.66,6.55a8.1,8.1,0,0,0,.79,3.32l10,22.58a5.77,5.77,0,0,0,5.76,3.88,15.37,15.37,0,0,0,4.12-.67,54.36,54.36,0,0,1,44.3,6.56c14,9,22.87,23.58,25,40.8.41,3.35,1.82,7.05,7.47,7.05h23.84C353.73,240.12,356.52,237.32,356.52,233.46Z" transform="translate(-1)"/>
    <path d="M476,185h.67c7.05-8.29,23.18-21.57,51.06-21.57,21.83,0,39,7.63,48.7,24.56,8.4-9.63,27.21-24.56,57.78-24.56,36.61,0,59.79,19.58,59.79,66V330H658V236.14c0-30-12.45-41.94-35-41.94-17.83,0-30.62,9-38.35,17a98.61,98.61,0,0,1,1.34,18V330H550V236.14c0-30-12.45-41.94-34.66-41.94-18.16,0-30.61,10.65-37.34,18.31V330H442V167h34Z" transform="translate(-1)"/>
    <path d="M797.22,233.68c-31.13-10-37.49-15.31-37.49-25.63,0-9.32,9-15,26.45-15,20.72,0,34.58,8.51,43,13.51l12-27.49c-8.7-5.66-25.11-15.64-55.58-15.64-35.82,0-59.92,17-59.92,45.93,0,28.62,18.41,40.27,48.54,50.59,30.13,10,35.83,16,35.83,26.3s-8.37,17.63-28.13,17.63c-24.05,0-39.12-10.66-46.51-17l-12.74,29.31c8.36,6.66,25.77,18.31,60.26,18.31,40.84,0,62.6-20.31,62.6-50.93C845.43,257,827.69,243.33,797.22,233.68Z" transform="translate(-1)"/>
    <path d="M994,292c-6.05,4-18.42,10.61-39.44,10.61-29.8,0-49.55-16.64-49.55-54.92,0-36.94,24.1-52.92,52.89-52.92,18.36,0,28.4,6.28,35.42,10.94l12.07-27.76c-9.36-6.56-23.11-14.46-51.17-14.46-43.52,0-86,26.62-86,85.87s33.14,85.21,81,85.21c32,0,48.86-10.12,56.68-15.24Z" transform="translate(-1)"/>
  </svg>
);

const MSC_LOGO_MARK = (
  <svg viewBox="0 0 370 500" xmlns="http://www.w3.org/2000/svg">
    <path d="M262.89,461.45a228.07,228.07,0,0,0,81-15.29,13.84,13.84,0,0,1,4.86-1.12c2.74,0,4.78,1.5,6.38,5.18l8.93,20.58a10,10,0,0,1,1,3.93c0,2.81-1.79,5.1-6.08,6.79A263.65,263.65,0,0,1,263.48,500,262.08,262.08,0,0,1,150.28,1.36,11.93,11.93,0,0,1,155.33,0c2.91,0,4.85,1.8,6.2,4.9L170,24.33a15.8,15.8,0,0,1,1.67,5.9c0,2.62-1.65,4.42-5.73,6.38C88.8,73.75,40,149.55,40,238c0,59.69,22.68,115.8,64.89,158A222,222,0,0,0,262.89,461.45Z" transform="translate(-1)"/>
    <path d="M331.15,396.85c0,2.88-1.91,4.93-6.35,6.6a175.26,175.26,0,0,1-61.9,11.17C165.51,414.62,86,335.39,86,238S165.51,61.37,262.9,61.37a175.13,175.13,0,0,1,63.4,11.74c2.85,1.09,4.74,3.07,4.74,6.15A11.45,11.45,0,0,1,330,83.78l-8.86,20.34c-1.51,3.47-3.3,5.16-6.19,5.16a13.38,13.38,0,0,1-4.55-1c-15-5.56-28.8-8.37-47.45-8.37-76.13,0-137.9,62-137.9,138.08s61.77,138.07,137.9,138.07A137,137,0,0,0,309.5,368a16.22,16.22,0,0,1,5.29-1.18c2.77,0,4.75,1.5,6.47,5.45l8.73,20A11.68,11.68,0,0,1,331.15,396.85Z" transform="translate(-1)"/>
    <path d="M356.52,233.46c0-.21,0-.42,0-.63-2.34-30.58-17.57-56.94-42.72-73a92.08,92.08,0,0,0-50.14-14.7,87.74,87.74,0,0,0-30,5c-3.76,1.47-5.66,3.74-5.66,6.55a8.1,8.1,0,0,0,.79,3.32l10,22.58a5.77,5.77,0,0,0,5.76,3.88,15.37,15.37,0,0,0,4.12-.67,54.36,54.36,0,0,1,44.3,6.56c14,9,22.87,23.58,25,40.8.41,3.35,1.82,7.05,7.47,7.05h23.84C353.73,240.12,356.52,237.32,356.52,233.46Z" transform="translate(-1)"/>
  </svg>
);

export default function LandingPage() {
  const { i18n } = useTranslation();
  const [activeIdx, setActiveIdx] = useState(0);
  const [lang, setLang] = useState(i18n.language?.slice(0, 2) || 'en');
  const trackRef = useRef(null);
  const idxRef   = useRef(0);

  useEffect(() => { idxRef.current = activeIdx; }, [activeIdx]);

  // Hide global navbar on landing page
  useEffect(() => {
    document.body.classList.add('landing-active');
    return () => document.body.classList.remove('landing-active');
  }, []);

  const moveTo = (idx, animated = true, snapBack = false) => {
    const track = trackRef.current;
    if (!track) return;
    if (animated) {
      track.getBoundingClientRect();
      track.style.transition = snapBack
        ? 'transform 0.7s cubic-bezier(0.16, 1, 0.3, 1)'
        : 'transform 0.9s cubic-bezier(0.16, 1, 0.3, 1)';
    } else {
      track.style.transition = 'none';
    }
    track.style.transform = `translateY(calc(-${idx} * 100dvh))`;
  };

  const navigateTo = (idx) => {
    const clamped = Math.max(0, Math.min(NUM_SLIDES - 1, idx));
    const track = trackRef.current;
    if (track) {
      const live = getComputedStyle(track).transform;
      track.style.transition = 'none';
      track.style.transform = live;
    }
    setActiveIdx(clamped);
    idxRef.current = clamped;
    moveTo(clamped, true);
  };

  // Touch & wheel gestures - same logic as Takes
  useEffect(() => {
    const touch = { startY: 0, lastY: 0, lastT: 0, velocity: 0 };

    const onTouchStart = (e) => {
      touch.startY   = e.touches[0].clientY;
      touch.lastY    = touch.startY;
      touch.lastT    = Date.now();
      touch.velocity = 0;
    };

    const onTouchMove = (e) => {
      e.preventDefault();
      const now = Date.now();
      const y   = e.touches[0].clientY;
      const dt  = now - touch.lastT;
      if (dt > 0) touch.velocity = (touch.lastY - y) / dt;
      touch.lastY = y;
      touch.lastT = now;
      const dragOffset = touch.startY - y;
      const track = trackRef.current;
      if (track) {
        track.style.transition = 'none';
        track.style.transform = `translateY(calc(-${idxRef.current} * 100dvh - ${dragOffset}px))`;
      }
    };

    const onTouchEnd = () => {
      const distance = touch.startY - touch.lastY;
      const triggered =
        Math.abs(touch.velocity) > VELOCITY_THRESHOLD ||
        Math.abs(distance)       > DISTANCE_THRESHOLD;
      if (triggered) {
        navigateTo(idxRef.current + (distance > 0 ? 1 : -1));
      } else {
        moveTo(idxRef.current, true, true);
      }
    };

    let wheelTimer = null;
    let wheelDelta = 0;
    const onWheel = (e) => {
      e.preventDefault();
      wheelDelta += e.deltaY;
      const track = trackRef.current;
      if (track) {
        track.style.transition = 'none';
        track.style.transform = `translateY(calc(-${idxRef.current} * 100dvh - ${wheelDelta}px))`;
      }
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(() => {
        const triggered = Math.abs(wheelDelta) > DISTANCE_THRESHOLD;
        if (triggered) {
          navigateTo(idxRef.current + (wheelDelta > 0 ? 1 : -1));
        } else {
          moveTo(idxRef.current, true, true);
        }
        wheelDelta = 0;
      }, 80);
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true  });
    document.addEventListener('touchmove',  onTouchMove,  { passive: false });
    document.addEventListener('touchend',   onTouchEnd,   { passive: true  });
    document.addEventListener('wheel',      onWheel,      { passive: false });

    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove',  onTouchMove);
      document.removeEventListener('touchend',   onTouchEnd);
      document.removeEventListener('wheel',      onWheel);
      clearTimeout(wheelTimer);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const changeLang = (l) => {
    setLang(l);
    i18n.changeLanguage(l);
  };

  return (
    <div className="lp-root">
      {/* Fixed overlays */}
      <div className="lp-badge">Demo</div>
      <div className="lp-copyright">Prototype by Ferdinand Riedl · riedlsoftware.com</div>

      {/* Progress dots */}
      <div className="lp-dots">
        {Array.from({ length: NUM_SLIDES }).map((_, i) => (
          <button key={i} className={`lp-dot${activeIdx === i ? ' active' : ''}`} onClick={() => navigateTo(i)} />
        ))}
      </div>

      {/* Sliding track */}
      <div className="lp-track" ref={trackRef}>

        {/* ── Slide 1: Hero ── */}
        <div className="lp-slide lp-hero">
          <div className="lp-hero-logo">{MSC_LOGO}</div>
          <div className="lp-hero-conf">Munich Voices by <b>Takes</b></div>
          <h1 className="lp-hero-title">Your voice in<br />global <strong>security</strong></h1>
          <p className="lp-hero-sub">Step into the room, cast your vote, and share your perspective on the issues that shape our world.</p>
          <Link to="/takes" className="lp-cta-btn">Join the conversation</Link>
        </div>

        {/* ── Slide 2: How it works (disabled) ── */}
        {false && <div className="lp-slide lp-how">
          <div className="lp-label">How it works</div>
          <h2 className="lp-how-title">Three steps to join<br />the conversation</h2>
          <div className="lp-steps">
            {[
              { n: '1', title: 'Read',    desc: 'Follow real-time quotes and insights from world leaders at the Munich Security Conference.' },
              { n: '2', title: 'Vote',    desc: 'Agree or disagree with each take. See how your perspective compares to attendees and viewers worldwide.' },
              { n: '3', title: 'Respond', desc: 'Share your own take. Contribute your voice to the global security dialogue alongside experts and citizens.' },
            ].map(({ n, title, desc }) => (
              <div key={n} className="lp-step">
                <div className="lp-step-num">{n}</div>
                <div>
                  <div className="lp-step-title">{title}</div>
                  <div className="lp-step-desc">{desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>}

        {/* ── Slide 3: Happening Now (disabled) ── */}
        {false && <div className="lp-slide lp-preview">
          <div className="lp-hn-label">
            <span className="lp-hn-dot" />
            Happening Now
          </div>
          <div className="lp-preview-card">
            <div className="lp-hn-type">Panel Discussion</div>
            <h3 className="lp-hn-title">Risks and Rewards of the AI Race</h3>
            <div className="lp-hn-rule" />
            <p className="lp-hn-latest-label">Latest</p>
            <p className="lp-preview-quote">
              <span className="lp-q">&ldquo;</span>
              The EU AI Act was designed for peacetime assumptions. We are now in a different strategic environment, and we need a wartime annex.
              <span className="lp-q">&rdquo;</span>
            </p>
            <div className="lp-preview-speaker">
              <img className="lp-preview-img" src="/img/nair.jpg" alt="Dr. Priya Nair" />
              <div>
                <div className="lp-preview-name">Dr. Priya Nair</div>
                <div className="lp-preview-role">Head of AI Policy, EU Commission</div>
              </div>
            </div>
            <Link to="/session/ai-race" className="lp-hn-join">
              Watch live
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3l5 5-5 5"/></svg>
            </Link>
          </div>
          <div className="lp-stats">
            {[
              { num: '24',    label: 'Live takes'   },
              { num: '1,247', label: 'Participants'  },
              { num: '8.4k',  label: 'Votes cast'   },
            ].map(({ num, label }) => (
              <div key={label} className="lp-stat">
                <div className="lp-stat-num">{num}</div>
                <div className="lp-stat-label">{label}</div>
              </div>
            ))}
          </div>
        </div>}

        {/* ── Slide 4: CTA (disabled) ── */}
        {false && <div className="lp-slide lp-cta-slide">
          <div className="lp-cta-logo">{MSC_LOGO_MARK}</div>
          <h2 className="lp-cta-title">Ready to weigh in?</h2>
          <p className="lp-cta-sub">It takes 30 seconds to get started. Tell us a bit about yourself and join the global conversation.</p>
          <Link to="/onboarding" className="lp-cta-btn">Join the conversation</Link>
          <p className="lp-cta-note">You'll answer two quick questions to help us show you relevant results.</p>
          <div className="lp-lang">
            {['en', 'de', 'fr'].map(l => (
              <button key={l} className={`lp-lang-btn${lang === l ? ' active' : ''}`} onClick={() => changeLang(l)}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>}

      </div>
    </div>
  );
}
